// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
export default function keyInObj(value, key, obj) {
  return key in obj;
}



//////////////////
// WEBPACK FOOTER
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/node_modules/underscore/modules/_keyInObj.js
// module id = 482
// module chunks = 1